const EmptySquareIcon = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18 5H8C6.34315 5 5 6.34315 5 8V18C5 19.6569 6.34315 21 8 21H18C19.6569 21 21 19.6569 21 18V8C21 6.34315 19.6569 5 18 5ZM8 4C5.79086 4 4 5.79086 4 8V18C4 20.2091 5.79086 22 8 22H18C20.2091 22 22 20.2091 22 18V8C22 5.79086 20.2091 4 18 4H8Z"
      fill="#C6CACE"
    />
  </svg>
);
export default EmptySquareIcon;
